import React from "react"
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
} from "@/components/ui/dialog"

interface ModalProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	title?: string
	description?: string
	children: React.ReactNode
}

export default function Modal(props: ModalProps) {
	return (
		<Dialog open={props.open} onOpenChange={props.onOpenChange}>
			<DialogContent className="overflow-y-auto h-[80vh] max-w-[90vw] md:max-w-[50vw]">
				<DialogHeader>
					<DialogTitle>{props.title}</DialogTitle>
					<DialogDescription>{props.description}</DialogDescription>
				</DialogHeader>
				{props.children}
			</DialogContent>
		</Dialog>
	)
}
